import styled from "styled-components";

export const Content = styled.div`
  padding: 30px;
  padding-bottom: 0px;
  margin-top: 100px;
  width: 100%;
  background-color: #f5f5f5;
`;

export const Title = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
  color: #00000099;
`;

export const Description = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
  color: #00000099;
`;

export const Container = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  min-height: calc(100vh - 300px);
  padding: 50px;
  display: flex;
  flex-direction: column;
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 16px;
`;

export const TeamGridWrapper = styled.div`
  max-height: 350px;
  overflow-y: auto;
  margin-top: 8px;

  &::-webkit-scrollbar-thumb {
    background-color: #a3a3a6;
    border-radius: 8px;
  }
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-track {
    border-radius: 8px;
  }
`;

export const ManagerListWrapper = styled.div`
  flex: 1;
  margin-bottom: 24px;
`;

export const ContainerFooter = styled.div`
  display: flex;
  justify-content: center;
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  gap: 16px;

  /* Ajuste em telas grandes/pequenas conforme desejado */
  @media (max-width: 3000px) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ManagerCard = styled.div`
  border-radius: 16px;
  display: flex;
  flex-direction: column;
`;

export const ManagerButton: any = styled.button`
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props: any) => props?.background};
  border-radius: 20px;
  border: 2px solid ${(props: any) => props?.border};
  overflow: hidden;
  cursor: pointer;
`;

export const ManagerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ManagerAvatar = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-left: 8px;
`;

export const ManagerDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

/**
 * Truncamos o nome/apelido do manager.
 */
export const ManagerName = styled.h3`
  color: #333333;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;

  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ManagerRole = styled.p`
  font-size: 14px;
  color: #333333;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: -0.01em;

  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/**
 * Aqui está o "segredo" da animação de abrir/fechar.
 * Sempre no DOM, mas com max-height e padding controlados por 'isOpen'.
 */
export const ManagerDetails = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;

  /* Ajuste a altura máxima de acordo com a possível altura do conteúdo */
  max-height: ${({ isOpen }) => (isOpen ? "800px" : "0")};

  /* Quando fechado, podemos remover o padding para "sumir" visualmente */
  padding: ${({ isOpen }) => (isOpen ? "16px" : "0 16px")};
`;

export const ContactInfo = styled.div`
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
  color: #666;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const ContactInfoText = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: #333333;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TeamHeading = styled.h4`
  font-size: 24px;
  color: #333;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  line-height: 29px;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
`;

export const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const TeamMemberCard = styled.div`
  display: grid;
  align-items: center;
  gap: 16px;
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
  grid-template-columns: repeat(2, 1fr);
`;

export const TeamMemberAvatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #808080;
`;

export const TeamMemberInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TeamMemberName = styled.h5`
  color: #333;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 29px;
  letter-spacing: -0.01em;

  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TeamMemberRole = styled.p`
  font-size: 12px;
  color: #666;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.01em;

  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
